import React from "react";
import { Switch, Route } from "react-router-dom";
import CertModal from "./CertModal";
import BeStarModal from "./BeStarModal";
import GuildInfoFormModal from "./GuildInfoFormModal";
import ChooseGuildTypeModal from "./ChooseGuildTypeModal";
import CheckOrderStatusModal from "./CheckOrderStatusModal";
import PaySuccessModal from "./PaySuccessModal";
import GuildServiceAgreement from "./GuildServiceAgreement";

/**
 * 使用 react router 管理各种弹窗, 每个路由对应一个弹窗
 * 参考例子: https://reactrouter.com/web/example/modal-gallery
 */

export enum ModalRoutes {
  // 根目录(不显示对话框)
  Root = "/",
  // 实名认证提示
  CertHint = "/cert-hint",
  // 星级公会流程
  BeStarGuildProcess = "/be-star-guild",
  // 公会资料填写页面
  GuildInfoForm = "/guild-info-form",
  // 选择成为普通公会还是星级公会
  ChooseGuildType = "/choose-guild-type",
  // 检查订单状态弹窗
  CheckOrderStatus = "/check-order-status",
  // 支付保证金额成功弹窗
  PaySuccess = "/pay-success",
  // 公会服务协议弹窗
  GuildServiceAgreement = '/guild-service-agreement'
}

export const closeModal = (history: any) => {
  return () => history.push(ModalRoutes.Root);
};

const ModalSwitch = () => {
  return (
    <Switch>
      {/* 实名认证提示 */}
      <Route path={ModalRoutes.CertHint} children={<CertModal />} />
      {/* 星级公会流程 */}
      <Route path={ModalRoutes.BeStarGuildProcess} children={<BeStarModal />} />
      {/* 公会资料填写页面 */}
      <Route path={ModalRoutes.GuildInfoForm} children={<GuildInfoFormModal />} />
      {/* 选择成为普通公会还是星级公会 */}
      <Route path={ModalRoutes.ChooseGuildType} children={<ChooseGuildTypeModal />} />
      {/* 检查订单状态弹窗 */}
      <Route path={ModalRoutes.CheckOrderStatus} children={<CheckOrderStatusModal />} />
      {/* 支付保证金额成功弹窗 */}
      <Route path={ModalRoutes.PaySuccess} children={<PaySuccessModal />}></Route>
      {/* 公会服务协议弹窗 */}
      <Route path={ModalRoutes.GuildServiceAgreement} children={<GuildServiceAgreement />}></Route>
    </Switch>
  );
};

export default ModalSwitch;
